import esriLoader from 'esri-loader';

// if the API hasn't already been loaded (i.e. the frist time this is run)
// loadModules() will call loadScript() and pass these options, which,
// in this case are only needed b/c we're using v3.x instead of the latest 4.x
/*const options = {
    url: 'http://192.168.1.49/arcgis_js_api/library/4.7/init.js'
};*/


const options = {
    // url: 'https://js.arcgis.com/4.7/'
    url: 'https://js.arcgis.com/4.9/'
    // url: 'https://js.arcgis.com/4.10/' //may be bug
    //url: 'https://js.arcgis.com/4.14/'
};

export default class portalAuth{
    loginPortal(){
        // first, we use Dojo's loader to require the map class
        return esriLoader.loadModules([
            "esri/portal/Portal",
            "esri/identity/OAuthInfo",
            "esri/identity/IdentityManager",
            "esri/portal/PortalQueryParams",
            "esri/request"
        ], options).then(([Portal, OAuthInfo, esriId,PortalQueryParams,esriRequest]) => {

            var info = new OAuthInfo({
                // Swap this ID out with registered application ID
                appId: process.env.__PORTAL_OAUTH_APP_ID__,
                // Uncomment the next line and update if using your own portal
                 portalUrl: process.env.__PORTAL_URL__,
                // Uncomment the next line to prevent the user's signed in state from being shared with other apps on the same domain with the same authNamespace value.
                // authNamespace: "portal_oauth_inline",
                popup: false
            });

            esriId.registerOAuthInfos([info]);
            return esriId.checkSignInStatus(info.portalUrl + "/sharing").then(
                (r)=> {
                    //test sample
                    // var sessionSample = {
                    //   "/": {
                    //     "https://egis-uat.hkairport.com/portal": {
                    //       "expires": 1535619280034,
                    //       "ssl": false,
                    //       "token": "qGtJ9pCxKExPdKpRNuB1CZKe57rQmq5XlKy7ZHIEBe1Gd5ZZTri3e1utsl8SqJyddR3shdr7hxwmgWxTAgBGxGskxOfUnBTiAt-zp8CJJQ2CvQA5GqEC634iH9x-nCHdAp8_Fz4AQ00F4h3f_qnNHpKLibFBS1Aj4mt9ptq5Udas0iRPyY2HTYzHolAl28rl",
                    //       "userId": "admin"
                    //     }
                    //   }
                    // };

                    //get sessionAuthObj from session storage
                    //the following code to login portal using sessionStorage information
                    var portalUrl = process.env.__PORTAL_URL__;
                    var sessionObj = JSON.parse(window.sessionStorage.getItem('esriJSAPIOAuth'));
                    // console.log('sessionObj', sessionObj)
                    if (sessionObj){
                        var sessionAuthObj = sessionObj["/"][portalUrl];
                        var selfInfoUrl = process.env.__PORTAL_SELF_INFO__ + sessionAuthObj.token;
                        // console.log(selfInfoUrl);
                        esriRequest(selfInfoUrl, {
                            responseType: "json"
                        }).then((selfInfoResponse) => {
                            // console.log("selfInfoResponse", selfInfoResponse)
                            sessionAuthObj.role = selfInfoResponse.role
                            var transformToLoginCookie = function (sessionToken) {
                                return {
                                    "portalApp": true,
                                    "email": sessionToken.userId,
                                    "token": sessionToken.token,
                                    "culture": selfInfoResponse.data.culture,
                                    "region": selfInfoResponse.data.region,
                                    "expires": sessionToken.expires,
                                    "allSSL": selfInfoResponse.ssl,
                                    "accountId": selfInfoResponse.data.orgId,
                                    "role": selfInfoResponse.data.role
                                }
                            }
                            var setCookie = function (cname, cvalue, exdays,domain) {
                                var d = new Date();
                                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                                var expires = "expires=" + d.toUTCString();
                                var cookieStr = cname + "=" + cvalue + ";" + expires + ";domain="+domain+";path=/";
                                // console.log(cookieStr);
                                document.cookie = cookieStr
                            }
                            var cookieObj = transformToLoginCookie(sessionAuthObj);
                            // console.log("cookieObj", cookieObj);
                            var cookieOjbStr = encodeURI(JSON.stringify(cookieObj))
                            var domain = window.location.hostname;
                            setCookie("esri_auth", cookieOjbStr, 30, domain);
                        });
                    }

                    return r
                }
            ).otherwise(
                function(e) {
                    console.log(e);
                    esriId.getCredential(info.portalUrl + "/sharing");

                    return e
                }
            );


        });
    }

    logout(routerInstance){
          // first, we use Dojo's loader to require the map class
          return esriLoader.loadModules([
            "esri/portal/Portal",
            "esri/identity/OAuthInfo",
            "esri/identity/IdentityManager",
            "esri/portal/PortalQueryParams"
        ], options).then(([Portal, OAuthInfo, esriId,PortalQueryParams]) => {
            //check if esri_auth is in cookie. It should exist if user already login at Portal.
            //ref: https://firstdoit.com/quick-tip-one-liner-cookie-read-c695ecb4fe59
            var esriAuthInCookie = ('; ' + document.cookie)
              .split('; ' + "esri_auth" + '=')
              .pop()
              .split(';')
              .shift()
            // window.alert(esriAuthInCookie);

            esriId.destroyCredentials();

            window.sessionStorage.clear();
           if(esriAuthInCookie){
                // var delete_cookie = function (name) {
                //     document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                // };
                var deleteCookie = function (cname,  domain) {
                  var d = new Date();
                  d.setYear("1970");
                  var expires = "expires=" + d.toUTCString();
                  var cookieStr = cname + "=;" + expires + ";domain=" + domain + ";path=/";
                  // console.log(cookieStr);
                  document.cookie = cookieStr
                }
                var domain = window.location.hostname;
                deleteCookie("esri_auth", domain);
                // var esriAuthInCookie2 = ('; ' + document.cookie)
                //   .split('; ' + "esri_auth" + '=')
                //   .pop()
                //   .split(';')
                //   .shift()
                // window.alert(esriAuthInCookie2);
                window.location = process.env.__PORTAL_URL__;
           }else{
                if(routerInstance){
                    routerInstance.push({ path: '/Login' })
                }else{
                    window.location = process.env.__PORTAL_URL__;
                }
           }
        });

    }
}






// WEBPACK FOOTER //
// ./src/service/portalAuth.js